module.exports = __webpack_public_path__ + "static/media/Artboard14.7372c036.png";